import ky from 'ky'
import {httpError} from '../utils/errors'

/**
 * EndpointService provides SIP endpoint API services
 */
class EndpointService {
    /**
     * getForAccount retrieves all endpoints for a given account from the server
     *
     * @param accountId
     * @returns {Promise<unknown>}
     */
    getForAccount = (accountId) => {
        return new Promise((resolve, reject) => {
            // Get the endpoint data, transforming any errors into a standardised error object
            const url = `/api/v2/accounts/${accountId}/endpoints`
            ky.get(url).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    /**
     * deactivate deactivates an endpoint
     *
     * @param accountId
     * @param endpointId
     * @returns {Promise<unknown>}
     */
    deactivate = (accountId, endpointId) => {
        return new Promise((resolve, reject) => {
            const url = `/api/v2/accounts/${accountId}/endpoints/${endpointId}`
            ky.delete(url)
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }
}

// Create a singleton instance of the service to export
const instance = new EndpointService();

export default instance;